/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_SettingsInputs */

const en_us2_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings change`)
};

const pt_br2_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração nas configurações`)
};

const es_419_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio en la configuración`)
};

const pt_pt2_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração nas definições`)
};

const fr_fr2_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification des réglages`)
};

const de_de2_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung der Einstellungen`)
};

const it_it2_offline_kind_settings = /** @type {(inputs: Offline_Kind_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica alle impostazioni`)
};

/**
* | output |
* | --- |
* | "Settings change" |
*
* @param {Offline_Kind_SettingsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_settings = /** @type {((inputs?: Offline_Kind_SettingsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_SettingsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_settings(inputs)
	if (locale === "es-419") return es_419_offline_kind_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_settings(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_settings(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_settings(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_settings(inputs)
	return en_us2_offline_kind_settings(inputs)
});
export { offline_kind_settings as "offline.kind_settings" }